import CartType from "@api/types/cart";
import { FC } from "react";

import CartLoading from "@components/CartLoading";
import CartPopulated from "@components/CartPopulated";

const Cart: FC<{ cart?: CartType }> = ({ cart }) => {
  return cart ? <CartPopulated cart={cart} /> : <CartLoading />;
};

export default Cart;
